import i18n from '@/lang/'

export const productIdentifier = {
  SINGLE_FM: 'p-fm-1',
  SINGLE_HSB: 'p-hsb-1',
  SINGLE_HOME: 'p-home-1',
  MULTI_HOME: 'p-home-2'
}

export const SeverityRanking = {
  Unknown: 0,
  CommsIssue: 50,
  Ready: 100,
  RunningOther: 200,
  RunningExercise: 300,
  RunningUtilityLoss: 400,
  Warning: 500,
  Fault: 600,
  FaultOff: 650
}

export const days = [
  { value: 0, text: i18n.t('xSunday') },
  { value: 1, text: i18n.t('xMonday') },
  { value: 2, text: i18n.t('xTuesday') },
  { value: 3, text: i18n.t('xWednesday') },
  { value: 4, text: i18n.t('xThursday') },
  { value: 5, text: i18n.t('xFriday') },
  { value: 6, text: i18n.t('xSaturday') }
]

export const intervals = [
  { value: 0, text: i18n.t('xWeekly') },
  { value: 1, text: i18n.t('xBiWeekly') },
  { value: 2, text: i18n.t('xMonthly') }
]

export const WeeklyInterval = 0
export const BiWeeklyInterval = 1
export const MonthlyInterval = 2

export const nexusExerciseInterval = [{ value: 0, text: i18n.t('xWeekly') }]

export const daysOfMonth = [
  { value: 1, text: '1st Day' },
  { value: 2, text: '2nd Day' },
  { value: 3, text: '3nd Day' },
  { value: 4, text: '4th Day' },
  { value: 5, text: '5th Day' },
  { value: 6, text: '6th Day' },
  { value: 7, text: '7th Day' },
  { value: 8, text: '8th Day' },
  { value: 9, text: '9th Day' },
  { value: 10, text: '10th Day' },
  { value: 11, text: '11th Day' },
  { value: 12, text: '12th Day' },
  { value: 13, text: '13th Day' },
  { value: 14, text: '14th Day' },
  { value: 15, text: '15th Day' },
  { value: 16, text: '16th Day' },
  { value: 17, text: '17th Day' },
  { value: 18, text: '18th Day' },
  { value: 19, text: '19th Day' },
  { value: 20, text: '20th Day' },
  { value: 21, text: '21st Day' },
  { value: 22, text: '22nd Day' },
  { value: 23, text: '23rd Day' },
  { value: 24, text: '24th Day' },
  { value: 25, text: '25th Day' },
  { value: 26, text: '26th Day' },
  { value: 27, text: '27th Day' },
  { value: 28, text: '28th Day' }
]

export const ManageMaintenancePanels = [
  '3',
  '03',
  '4',
  '04',
  '5',
  '05',
  '6',
  '06',
  '7',
  '07',
  '8',
  '08',
  '9',
  '09',
  '10',
  '11',
  '12',
  '13',
  '14',
  '21',
  '22',
  '23',
  '25'
]

export const YellowstonePanelIdString = '25'

export const CanSendActionCommands = ['21', '22', '23', '25']

export const NexusPanels = ['3', '03', '4', '04', '5', '05', '6', '06', '7', '07', '8', '08']

export const CountriesGetPaidSubs = ['US', 'CA']

export const TanksAllowedCountries = [
  /** United States */
  'US',
  /** Canada */
  'CA',
  /** Puerto Rico*/
  'PR',
  /** Virgin Islands */
  'VI',
  /** Guam */
  'GU'
]

export const HsbMaintenanceTypes = [
  { name: i18n.t('xChangedOilAndFilter'), selected: false },
  { name: i18n.t('xChangedAirFilter'), selected: false },
  { name: i18n.t('xChangedSparkPlug'), selected: false },
  { name: i18n.t('xCheckedOilLevel'), selected: false },
  { name: i18n.t('xInspectedBattery'), selected: false },
  { name: i18n.t('xReplacedBattery'), selected: false },
  { name: i18n.t('xCheckedFuelLines'), selected: false },
  { name: i18n.t('xCheckedLouvers'), selected: false },
  { name: i18n.t('xCompletedScheduledMaintenance'), selected: false }
]
export const PortableMaintenanceTypes = [
  { name: i18n.t('xChangedAirFilter'), selected: false },
  { name: i18n.t('xChangedSparkPlug'), selected: false },
  { name: i18n.t('xChangedOil'), selected: false }
]

export const ApparatusStatus = {
  Commissioned: 'Commissioned',
  Manufactured: 'Manufactured',
  Retired: 'Retired'
}

export const PreprodSlotName = 'preprod'

/** These MUST match the value in Generac.Application.MobileLink.Models.Apparatus.Enumerations.ApparatusType. */
export const HsbApparatusType = 0
export const IndustrialGenApparatusType = 1
export const FuelTankApparatusType = 2
export const PortableBatteryApparatusType = 3
export const PortableGeneratorApparatusType = 4
export const PortableInverterApparatusType = 5
export const VehicleChargerApparatusType = 6
export const ThermostatApparatusType = 7

/**
 * These correspond to the Generac.Application.MobileLink.Models.Apparatus.Enumerations.ApparatusPropertyType in the API repo.
 * These constants helps the MobileLink website understand what the values on `apparatus<Apparatus>.properties` represent.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 */
export const ApparatusPropertyGeneral = 0
export const ApparatusPropertyConnectionType = 1
export const ApparatusPropertySubscription = 2
export const ApparatusPropertyDevice = 3

/**
 * These correspond to the Generac.Application.MobileLink.Models.Subscription.Enumerations.OrganizationSubscriptionStatus in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 * @note These are for the new IAP/modern subscriptions.
 */
export const SubscriptionDetailPurchaseIntent = 0
export const SubscriptionDetailActive = 1
export const SubscriptionDetailPendingCancel = 2
export const SubscriptionDetailCanceled = 3
export const SubscriptionDetailPendingProductChange = 4
export const SubscriptionDetailRefund = 5

/**
 * These correspond to the Generac.Application.MobileLink.Models.Subscription.Enumerations.OrganizationSubscriptionReason in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 * @note These are for the new IAP/modern subscriptions.
 */
export const SubscriptionDetailsReasonPurchase = 0
export const SubscriptionDetailsReasonRenewal = 1
export const SubscriptionDetailsReasonChangedApparatus = 2
export const SubscriptionDetailsReasonPendingChangeCanceled = 3
export const SubscriptionDetailsReasonUserDisabledAutoRenew = 4
export const SubscriptionDetailsReasonUserCanceled = 5
export const SubscriptionDetailsReasonGracePeriodStarted = 6
export const SubscriptionDetailsReasonGracePeriodExpired = 7
export const SubscriptionDetailsReasonRefundIssued = 8
export const SubscriptionDetailsReasonRefundReversed = 9
export const SubscriptionDetailsReasonUpgrade = 10
export const SubscriptionDetailsReasonDowngrade = 11
export const SubscriptionDetailsReasonPendingPurchaseCanceled = 12
export const SubscriptionDetailsReasonPendingCancelReverted = 13

/** LEGACY: These values correspond to the enum at Generac.Application.MobileLink.Models.Apparatus.Enumerations.SubscriptionStatuses.
 * The numbers MUST match the values in that enum.
 * */
export const SubscriptionInactive = 0
export const SubscriptionActive = 1
export const SubscriptionPendingCancellation = 2
export const SubscriptionPendingTermination = 3
export const SubscriptionSuspended = 4
export const SubscriptionCancelled = 5
export const SubscriptionTerminated = 6
export const SubscriptionPendingSuspension = 7
export const SubscriptionDunning = 8
//string subscription statuses (legacy)
export const PendingCancellationStatus = 'PendingCancellation'
export const ActiveStatus = 'Active'
export const InactiveStatus = 'Inactive'
export const PendingTermination = 'PendingTermination'
export const SuspendedStatus = 'Suspended'
export const CancelledStatus = 'Cancelled'
export const TerminatedStatus = 'Terminated'
export const PendingSuspensionStatus = 'PendingSuspension'

//string dunning statuses (legacy)
export const DunningInProgress = 'InProgress'

export const DealerManagedProductName = 'Dealer Managed'

/** These values correspond to the enum at Generac.Application.MobileLink.Models.Apparatus.Enumerations.SubscriptionTypes.
 * The numbers MUST match the values in that enum.
 * */
export const NoSubscription = 0
export const FreeSubscription = 1
export const PaidSubscription = 2
export const ManagedSubscription = 3

export const CdmaUpgradeRemindMeDate = 'cdmaUpgradeRemindMeDate'
export const CdmaUpdateRemindMeDays = 'CdmaUpdateRemindMeDays'
export const CdmaUpgradeShowPopUp = 'CdmaUpgradeShowPopUp'
export const CdmaUpgradeLearnMoreDate = 'cdmaUpgradeLearnMoreDate'

export const DisplayDistanceUom = 'displayDistanceUom'
export const DisplayTemperatureUom = 'displayTemperatureUom'

export const FreeWifiEthProductId = 'p-free-wifi-annual'
export const WiFiMonthlyProductId = 'p-premium-wifi-monthly'
export const WiFiAnnualProductId = 'p-premium-wifi-annual'
export const EthMonthlyProductId = 'p-premium-eth-monthly'
export const EthAnnualProductId = 'p-premium-eth-annual'
export const LteMonthlyProductId = 'p-premium-lte-monthly'
export const LteAnnualProductId = 'p-premium-lte-annual'
export const CdmaMonthlyProductId = 'p-premium-cdma-monthly'
export const CdmaAnnualProductId = 'p-premium-cdma-annual'
export const DealerManagedProductId = 'p-free-dealermanaged-annual'
export const TankUtilityFreeProductId = 'p-free-tankutility-monthly'
export const TankUtilityPremiumProductId = 'p-premium-tankutility-annual'
export const TankUtilityDealerManagedProductId = 'p-free-dealermanaged-tankutility-annual'
export const PortablesProductId = 'p-free-portablegenerator-monthly'
export const SingleFuelMonitorMonthlyProductId = 'p-fm-1-monthly'
export const SingleFuelMonitorYearlyProductId = 'p-fm-1-yearly'
export const SingleGeneratorMonthlyProductId = 'p-hsb-1-monthly'
export const SingleGeneratorYearlyProductId = 'p-hsb-1-yearly'
export const HomePremiumOneYearlyProductId = 'p-home-1-yearly'
export const HomePremiumOneMonthlyProductId = 'p-home-1-monthly'
export const HomePremiumMultiHomeYearlyProductId = 'p-home-2-yearly'
export const HomePremiumMultiHomeMonthlyProductId = 'p-home-2-monthly'

export const TransferTypeGenerator = 'FreeGenerator'
export const TransferTypeAccount = 'Account'

/**
 * These correspond to the Generac.Application.MobileLink.Models.Apparatus.Enumerations.ApparatusStatus in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 */
export const StatusIsUnknown = 0
export const StatusIsReady = 1
export const StatusIsRunning = 2
export const StatusIsExercising = 3
export const StatusIsWarning = 4
export const StatusIsFault = 5
export const StatusIsCommsIssue = 6
export const StatusIsDisconnected = 7
export const StatusIsSwitchedOff = 8

export const BillingMigrationFeatureFlag = 'Any_Billing_Maintenance'
export const MessageCenterFF = 'Any_MessageCenter'
export const WebBannerMessageConfig = 'Web_Banner_Message'
export const DocumentsStatementsFF = 'Any_DocumentsStatementsPage'
export const TankMonitorInstallVideoUrlConfig = 'TankUtility_Setup_Video_Url'
export const AddPortablesGenBtOnDashboardFF = 'Any_PortableGeneratorMaintenance'
export const G3DeviceFeatureFlag = 'Web_G3_Feature_Flag'
export const DashboardShowMigrationBannerFF = 'Web_Show_Migration_Banner'
export const ShowLegacyOverProductLimitBannerFF = 'Web_ShowLegacyOverProductLimitBanner'
export const useAuth0FeatureFlag = 'Web_UseAuth0'
export const useAuth0AndB2CFeatureFlag = 'Web_UseAuth0AndB2C'
export const useWebSecurityUpdateComingSoonBannerFeatureFlag = 'Web_SecurityUpdateComingSoonBanner'

/**
 * These correspond to the sGenerac.Application.MobileLink.Models.TankUtility.Enumerations.TankDeviceIdValidationCode in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 */
export const TankDeviceIdValidationCode_Available = 0
export const TankDeviceIdValidationCode_AlreadyEnrolled = 1
export const TankDeviceIdValidationCode_NotFound = 2
export const TankDeviceIdValidationCode_WiFiNotDeployed = 3
export const TankDeviceIdValidationCode_DisabledDealerManaged = 4
export const TankDeviceIdValidationCode_DisabledNonDealerManaged = 5

/**
 * These correspond to the Generac.Application.MobileLink.Models.MessageCenter.MessageCategories in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 */
export const AccountMessagesMessageCategory = 0
export const AppUpdatesMessageCategory = 1

/**
 * These numbers MUST correspond with the enum index of the corresponding SNMP in the
 * Generac.Application.MobileLink.Models.Apparatus.Enumerations.TankUtilitySnmps in the API code.
 */
export const TuSnmpTypeFuelType = 0
export const TuSnmpTypeCapacity = 1
export const TuSnmpTypeOrientation = 2
export const TuSnmpTypeConsumptionTypes = 3
export const TuSnmpTypeFixedTransmissionTime = 4
export const TuSnmpTypeReadingLevel = 5
export const TuSnmpTypeTransmissionInterval = 6
export const TuSnmpTypeThreshold1 = 7
export const TuSnmpTypeThreshhold2 = 8
export const TuSnmpTypeFuelLevel = 9
export const TuSnmpTypeTemperature = 10
export const TuSnmpTypeLastReading = 11
export const TuSnmpTypeDeviceVersion = 12
export const TuSnmpTypeFuelDealerId = 13
export const TuSnmpTypeStatus = 14
export const TuSnmpTypeAverageConsumption = 15
export const TuSnmpTypeChangeOfValue = 16
export const TuSnmpTypeBatteryLevel = 17

/**
 * These correspond to the Generac.Application.MobileLink.Models.PreferenceType in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 */
export const PreferenceTypeUnknown = 0
export const PreferenceTypeStatusChange = 1
export const PreferenceTypeFault = 2
export const PreferenceTypeWarning = 3
export const PreferenceTypeMaintenance = 4
export const PreferenceTypeExercise = 5
export const PreferenceTypeWeeklySummary = 6
export const PreferenceTypeMonthSummary = 7
export const PreferenceTypeMessage = 8
export const PreferenceTypeGridServices = 9
export const PreferenceTypeTankBatteryWarning = 10
export const PreferenceTypeTankBatteryCritcal = 11
export const PreferenceTypeTankFuelWarning = 12
export const PreferenceTypeDisconnected = 13

/**
 * These correspond to the Generac.Application.MobileLink.Services.Event.Models.EventType in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 */
export const UpgradeEventType = 0
export const DowngradeEventType = 1
export const TransferEventType = 2
export const CancelEventType = 3
export const RemoveEventType = 4
export const GetStartedVisit = 5

export const LimitReachedHelpArticleUrl =
  'https://support.generac.com/s/article/Why-did-I-get-a-limit-reached-error-in-Mobile-Link'

export const HowToUpgradeHelpUrl =
  'https://support.generac.com/s/article/How-Do-I-Upgrade-My-CDMA-Device-to-the-LTE-Device'

export const RequestDealerUrl = 'https://www.generac.com/support/request-service-standby-generators/'

export const GoogleStoreMobileLinkURL =
  'https://play.google.com/store/apps/details?id=com.generac.standbystatus&hl=en_US&pli=1'
export const AppleStoreMobileLinkURL = 'https://apps.apple.com/us/app/mobile-link-for-generators/id829129497'
export const CDMADoNotUpgradePanels = ['18', '19', '20']

export const TankUtilityWifiDeviceType = 'wifi-tankutility-v1'
export const TankUtilityLteDeviceTypeV1 = 'lte-tankutility-v1'
export const TankUtilityLteDeviceTypeV2 = 'lte-tankutility-v2'
export const HsbWifiDeviceType = 'wifi'
export const HsbLteDeviceType = 'lte'
export const HsbEthDeviceType = 'eth'
export const HsbCdmaDeviceType = 'cdma'
export const HsbG3DeviceType = 'dual-generator-v1'

export const HeatingOilSnmpValue = 'heating_oil'
export const TuPropertiesOilValue = 'oil' // Comes through in TuProperties as "Oil", not "heating_oil." Not sure why that discrepancy exists

export const TankSnmpNames = {
  threshold1: 'Threshold1'
}

export const ANNUAL = 'annual'
export const MONTHLY = 'monthly'
export const FREE = 'free'

export const DealerCategoryResidetialAndCommercialDealers = 'ResidetialAndCommercialDealers'
export const DealerCategoryPortablesDealers = 'PortablesDealers'

export const UserEmailLocalStorageKey = 'userEmail'
export const ForceSignOutErrorLocalStorageKey = 'signOutErrorMessage'

// Store options are: 0 = Apple, 1 = Google, 2 = Web, 3 = Dealer
export const SubscriptionStoreTypes = {
  APPLE: 'Apple',
  GOOGLE: 'Google',
  WEB: 'Web',
  DEALER: 'Dealer'
}

/**
 * These correspond to the Generac.Application.MobileLink.Models.Subscription.Enumerations.OrganizationSubscriptionStores in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 */
export const AppleSubscriptionStore = 0
export const GoogleSubscriptionStore = 1
export const WebSubscriptionStore = 2
export const DealerSubscriptionStore = 3

export const GoogleStoreURL = 'https://play.google.com/store/account/subscriptions'
export const AppleStoreURL = 'https://account.apple.com/account/manage/section/subscriptions'

export const GooglePlayStorePaymentURL = 'https://play.google.com/store/paymentmethods'

export const SubscriptionDurations = {
  YEARLY: 'yearly',
  MONTHLY: 'monthly'
}

export const ApparatusTypesAsString = {
  0: 'Generator',
  1: 'IndustrialGenerator',
  2: 'FuelTank',
  3: 'PortableBattery',
  4: 'PortableGenerator',
  5: 'PortableInverter',
  6: 'VehicleCharger',
  7: 'Thermostat'
}

export const HsbApparatusStringType = 'Generator'
export const IndustrialGenApparatusStringType = 'IndustrialGenerator'
export const FuelTankApparatusStringType = 'FuelTank'
export const PortableBatteryApparatusStringType = 'PortableBattery'
export const PortableGeneratorApparatusStringType = 'PortableGenerator'
export const PortableInverterApparatusStringType = 'PortableInverter'
export const VehicleChargerApparatusStringType = 'VehicleCharger'
export const ThermostatApparatusStringType = 'Thermostat'

export const ApparatusTypeToString = {
  [HsbApparatusType]: HsbApparatusStringType,
  [IndustrialGenApparatusType]: IndustrialGenApparatusStringType,
  [FuelTankApparatusType]: FuelTankApparatusStringType,
  [PortableBatteryApparatusType]: PortableBatteryApparatusStringType,
  [PortableGeneratorApparatusType]: PortableGeneratorApparatusStringType,
  [PortableInverterApparatusType]: PortableInverterApparatusStringType,
  [VehicleChargerApparatusType]: VehicleChargerApparatusStringType,
  [ThermostatApparatusType]: ThermostatApparatusStringType
}

export const HSB_MAX_AMOUNT = 2
export const FUEL_MONITOR_MAX_AMOUNT = 4

export const ConnectionTroubleshootingLteLink = 'https://support.generac.com/mobilelink/s/global-search/LTE'
export const ConnectionTroubleshootingWifiLink =
  'https://support.generac.com/mobilelink/s/global-search/wifi%20troubleshooting'
export const ConnectionTroubleshootingG3Link =
  'https://support.generac.com/mobilelink/s/global-search/Connectivity-Cellular-Accessory'

/**
 * These correspond to the Generac.Application.MobileLink.Models.Migration.v1 type in the API repo.
 * @important The numbers associated with each enum member MUST match the corresponding enum member number in the C# enum.
 */
export const MigrationStatusTypes = {
  /**This value is obsolete and is no longer returned from Platform -- Keeping in enum for completeness sake */
  Invalid: 0,
  /**The user has a B2C account */
  Valid: 1,
  /**The user does not have a B2C account */
  New: 2,
  /**This value is obsolete and is no longer returned from Platform -- Keeping in enum for completeness sake */
  AutoEnroll: 3,
  /**This value is obsolete and is no longer returned from Platform -- Keeping in enum for completeness sake */
  Legacy: 4,
  /**There was a failed dependency on Platform's side and the migration status can be re-requested */
  Retry: 5,
  /**The API returned an error and the migration status of the account is not known */
  Unknown: 6
}
/**
 * This correspond to the Generac.Application.MobileLink.Helpers.AuthConstants value of the same name in the API repo.
 * @important This value must match the value  of the same name in the API Repo file listed above .
 */
export const REDIRECT_TO_LOGOUT_HEADER = 'x-redirect-to-logout'
